module.exports = __webpack_public_path__ + "static/media/Back_Arrow@3x.6ffb3c60.png";